import { UserAgreementModal } from '@/components/UserAgreementModal.tsx'
import { useUserContext } from '@/contexts/UserContext.tsx'
import { updateUsername } from '@/repositories/userManagementRepository.ts'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const WelcomePage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, setUser, isLoading } = useUserContext()

  const [open, setOpen] = useState(false)

  const onSubmit = (username: string) => {
    updateUsername(username).then(() => {
      if (user) {
        setUser({ ...user, username })
        setOpen(false)
      }
    })
  }

  useEffect(() => {
    if (!isLoading) {
      if (!user) {
        navigate('/login')
      }

      if (user?.username) {
        navigate('/projects')
      } else {
        setOpen(true)
      }
    }
  }, [user, navigate, isLoading])

  return (
    <>
      <UserAgreementModal open={open} invitedProject={location.state?.project} onSubmit={onSubmit} />
    </>
  )
}
